export enum APLAMSTranslationCodes {
  search_description = 'aplAMS:search_description',
  company_name_filter = 'aplAMS:company_name_filter',
  country_filter = 'aplAMS:country_filter',
  tax_id_filter = 'aplAMS:tax_id_filter',
  search_tax_id_requirements = 'aplAMS:search_tax_id_requirements',
  search_location_id_requirements = 'aplAMS:search_location_id_requirements',
  search_company_name_requirements = 'aplAMS:search_company_name_requirements',
  search_button = 'aplAMS:search_button',
  country_column = 'aplAMS:country_column',
  legal_name_column = 'aplAMS:legal_name_column',
  tax_id_column = 'aplAMS:tax_id_column',
  print_hw_column = 'aplAMS:print_hw_column',
  supplies_column = 'aplAMS:supplies_column',
  bps_column = 'aplAMS:bps_column',
  cps_column = 'aplAMS:cps_column',
  restrictions_column = 'aplAMS:restrictions_column',
}
